export default __webpack_public_path__ + "static/media/unfinalize_other_agenda.f48ce683.svg";